<div class="splash d-flex justify-center bg-white dark:bg-neutral-950">
    <div class="max-w-[260px] m-auto">
        <div class="flex items-center gap-x-1 animated pulse infinite">
            <img class="inline-block size-12 rounded-sm dark:hidden" src="/assets/images/logo_dark.png" alt="Kreador logo">
            <img class="hidden size-12 rounded-sm dark:inline-block" src="/assets/images/logo.png" alt="Kreador logo">
            <div class="grow ms-1">
                <a class="relative flex-none font-bold text-3xl text-[#000] dark:text-white focus:outline-hidden dark:text-[#000]" aria-label="Brand">
                   reador <span class="text-gray-500 dark:text-neutral-400 font-normal">Suite</span>
                </a>
            </div>
        </div>
    </div>
</div>